import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAuthHandling } from '../useAuthhandling';
import Cookies from 'js-cookie';
import Config from '../Config';
import { Navbar } from 'reactstrap';
import Sidebar from '../Sidebar';

function Testimonialview() {

    let navigate = useNavigate();
    const { isAuthorized, handleUnauthorized } = useAuthHandling();
    const [testimonial,setTestimonial]=useState([]);
    const[prof,setProf]=useState([]);
    const tokens = Cookies.get("a_token");
    if (!tokens) {
      navigate("/");
    }
    let { id } = useParams();

    const getinfo = async (e) => {
        const res = await fetch(
          `${Config.apiurl}/api/v1/crm/review/get-testimonial/${id}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${Cookies.get("a_token")}`,
            },
          }
        );
        if (res.status === 200) {
          const data = await res.json();
    
          setTestimonial(data.data);
        } 
        else if(res.status === 401){
          handleUnauthorized();
          getinfo();
        }
        else {
          alert("error");
    
        }
      };
      const getprof = async (e) => {
        const res = await fetch(
            `${Config.apiurl}/api/v1/crm/customer/get-customers-dropdown`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${Cookies.get("a_token")}`,
              },
            }
          );
      
        const data1 = await res.json();
        const data = data1.data;
        if (res.status === 404 || !data) {
          console.log("error");
        } 
        else if(res.status===401){
          handleUnauthorized();
          getprof();
        }
        else {
          setProf(data);
        }
      };
    

      useEffect(() => {
        getinfo();
     getprof();

      }, []);
    
  return (
    <div className="container-scroller">
            <Navbar />

            <div className="container-fluid page-body-wrapper">
                <Sidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className='view_page_top'>
                            <Link to="/testimoniallist">Testimonial list</Link>
                        </div>
                        <div className="row">
                            <div className="col-md-12 grid-margin stretch-card">
                                <div className="card">
                                    <div className="card-body">
                                        <h4 className="card-title">Testimonial View page</h4>

                                        <div className='row view_div_row'>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6>Author </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                    {prof.map((prof,i)=>{
                                                            return(
                                                                <>
                                                                {prof._id===testimonial.author?
                                                                <p> {prof.name}</p>
                                                                :""
                                                                }
                                                                </>
                                                            )
                                                        })}
                                                       
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6'>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Author Type </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {testimonial.authorType}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-6 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Rating </h6>
                                                    </div>

                                                    <div className='view_portion_p'>
                                                        <p>  {testimonial.rating}</p>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className='col-12 '>
                                                <div className='view_portion'>
                                                    <div className='view_portion_h6'>
                                                        <h6> Review </h6>
                                                    </div>
                                                    <div className='view_portion_p'>
                                                        <p>  {testimonial.reviews}</p>
                                                    </div>

                                                </div>
                                            </div>
                                           
                                           
                                           
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default Testimonialview
